import { useTranslations } from 'next-intl';
import { Controller, useFormContext } from 'react-hook-form';
import { CatInputField } from 'components/blocks-components';
import { Conditional } from '@cat-ecom/pcc-components';
import { BlocksChangeEvent } from 'blocks-nextjs/blocks-web-components/events';
import { setInputValue } from '../utils';

export const BrazilTaxForm = () => {
  const t = useTranslations();
  const { control, watch, setValue, getValues } = useFormContext();
  const selectedTaxIdOption = watch('taxIdOption');
  return (
    <>
      <Conditional test={!!selectedTaxIdOption}>
        <Conditional
          test={selectedTaxIdOption === t('UR_CAT_INDIVIDUAL')}
          fallback={
            <Controller
              name={'taxIdCNPJ'}
              control={control}
              rules={{
                required: true
              }}
              render={({ field }) => (
                <CatInputField
                  {...field}
                  name={'taxIdCNPJ'}
                  label={'CNPJ'}
                  required
                  data-testid="taxIdCNPJ"
                  fieldId={'taxIdCNPJ'}
                  onBlChange={(e: BlocksChangeEvent) =>
                    setInputValue(e, setValue, 'taxIdCNPJ')
                  }
                  value={getValues('taxIdCNPJ')}
                  className="mb-3"
                />
              )}
            ></Controller>
          }
        >
          <Controller
            name={'taxIdCPF'}
            control={control}
            rules={{
              required: true
            }}
            render={({ field }) => (
              <CatInputField
                {...field}
                name={'taxIdCPF'}
                label={'CPF'}
                required
                data-testid="taxIdCPF"
                fieldId={'taxIdCPF'}
                onBlChange={(e: BlocksChangeEvent) =>
                  setInputValue(e, setValue, 'taxIdCPF')
                }
                value={getValues('taxIdCPF')}
                className="mb-3"
              />
            )}
          ></Controller>
        </Conditional>
      </Conditional>
      <Conditional test={selectedTaxIdOption === t('UR_CAT_COMPANY')}>
        <Controller
          name="stateTaxId"
          control={control}
          rules={{
            required: true
          }}
          render={({ field }) => (
            <CatInputField
              {...field}
              name="stateTaxId"
              label={t('STATE_TAX_ID')}
              required
              fieldId="stateTaxId"
              onBlChange={(e: BlocksChangeEvent) =>
                setInputValue(e, setValue, 'stateTaxId')
              }
              className="mb-3"
            />
          )}
        ></Controller>
        <Controller
          name="neighborhood"
          control={control}
          rules={{
            required: true
          }}
          render={({ field }) => (
            <CatInputField
              {...field}
              name="neighborhood"
              label={t('NEIGHBORHOD')}
              required
              fieldId="neighborhood"
              onBlChange={(e: BlocksChangeEvent) =>
                setInputValue(e, setValue, 'neighborhood')
              }
              className="mb-3"
            />
          )}
        ></Controller>
      </Conditional>
    </>
  );
};
